import { RegistrationStore } from "@state/stores/membership/registration";
import { useContext, createContext } from "react";

export const RegistrationStoreContext = createContext({} as RegistrationStore);

export const useRegistrationStore = () => {
	return useContext(RegistrationStoreContext);
};
